import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ApiStatus } from "services/common"

interface CaptureStagedFinalPaymentResponse extends AxiosResponse {
  data: {
    data: boolean
    bookingId: number
    bookingNo: string
    bookingTotalAmount: number
    isFirstLogin: boolean
    message: string
    status: number
    updateEmail: boolean
    updateMobile: boolean
    apiStatus: ApiStatus
    errorMessage: string
  }
}

export interface CaptureStagedFinalPaymentRequest
  extends Partial<AxiosRequestConfig> {
  bookingNumber: string
}

export function captureStagedFinalPaymentApi(
  { bookingNumber, ...config }: CaptureStagedFinalPaymentRequest,
  axiosInstance: AxiosInstance,
): Promise<CaptureStagedFinalPaymentResponse> {
  return axiosInstance({
    method: "post",
    url: `/admin/booking/capture-staged-final-payment?bookingNumber=${bookingNumber}`,
    ...config,
  }) as Promise<CaptureStagedFinalPaymentResponse>
}
